import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4a740682"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "hingeThickness" }, "Hinge Thickness:", -1))
const _hoisted_2 = {
  key: 0,
  class: "ph-error"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Value must be a decimal between ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, ".001", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" and ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, ".500", -1))
const _hoisted_7 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 1,
  class: "ph-error"
}

import { PreHangOption } from '@/types/preHang'
    import { PropType, ref, watch } from 'vue'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'HingeThickness',
  props: {
        value: { type: Object as PropType<PreHangOption | null>, required: false },
        hasRequiredError: { type: Boolean, required: false, default: false }
    },
  emits: ['select'],
  setup(__props, { emit: emits }) {

const props = __props

    

    
    const selection = ref<string>('')
    const hasError = ref<boolean>(false)

    function isValidInput(num: any) {
        return !isNaN(num) && num > .001 && num < .5
    }

    function cleanSelection(str: string) {
        let fraction
        const clean = str.replace(/[^\d./]/g, '')
        if(clean.includes('/')) {
            const split = clean.replace(/[.]/g,'').split('/')
            const numerator = parseInt(split[0])
            const denominator = parseInt(split[1])
            fraction = numerator / denominator
        }

        return (fraction) ? fraction.toString() : clean
    }

    function handleSelection() {
        hasError.value = false
        selection.value = cleanSelection(selection.value)
        if(isValidInput(selection.value) || selection.value === '') {
            if(selection.value != props.value?.name) {
                const selectedOption: PreHangOption = {
                    id: 555,
                    name: selection.value,
                    preHangCategoryId: 29,
                    price: 0
                }
                emits("select", selectedOption, 'machineHingeThickness')
            }
        } else {
            hasError.value = true
        }
    }

    watch(() => props.value, (current, old) => {
        if(current && current.name) {
            selection.value = current.name
        } else {
            selection.value = ''
        }
    },{immediate: true})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: "ph-hingeThickness",
    class: _normalizeClass(["form-group text-left", {'error':hasError.value || props.hasRequiredError}])
  }, [
    _hoisted_1,
    _withDirectives(_createElementVNode("input", {
      id: "hingeThickness",
      class: "form-control",
      type: "text",
      onChange: handleSelection,
      placeholder: "Enter Decimal or Fraction",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selection).value = $event))
    }, null, 544), [
      [_vModelText, selection.value]
    ]),
    (hasError.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _hoisted_7))
      : (props.hasRequiredError)
        ? (_openBlock(), _createElementBlock("p", _hoisted_8, "Selection required."))
        : _createCommentVNode("", true)
  ], 2))
}
}

})